import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ContextShare from './ContextShare/ContextShare';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import ErrorBoundary from './ErrorBoundary'; // Import the ErrorBoundary component
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
  <ContextShare>
  {/* <ErrorBoundary>  */}
          <App />
        {/* </ErrorBoundary> */}
  </ContextShare>
  </BrowserRouter>
  // </React.StrictMode>
);





